import type { CardItemBreederData, CardItemLitterData } from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { ReactNode } from 'react';

export interface BreedPageContent {
  synologyRank?: string;
  historic?: string;
  morphology?: string;
  fragilities?: string;
  advices?: string;
}

export interface BreedPageInfoDetail {
  label: string;
  value: string;
}

export interface BreedPageInfoAttribute {
  label: string;
  value: number;
}

export interface BreedPageInfoAttributeCategory {
  categoryName: string;
  attributes: BreedPageInfoAttribute[];
}

export interface BreedPageImages {
  background?: string;
  profile?: string;
}

export interface BreedPageGenetics {
  text: string;
  items: string[];
}

export interface BreedPageData {
  name?: string;

  title?: string;
  description?: string;
  content?: BreedPageContent;
  details?: BreedPageInfoDetail[];
  attributeCategories?: BreedPageInfoAttributeCategory[];
  images?: BreedPageImages;
  genetics?: BreedPageGenetics;

  litterItems?: CardItemLitterData[];
  breederItems?: CardItemBreederData[];
  litterItemsLoading?: boolean;
  breederItemsLoading?: boolean;
  moreLittersLink?: LocationDescriptor;
  moreBreedersLink?: LocationDescriptor;
  subscribeBtn: ReactNode;
  showLittersCta?: boolean;
  showBreedersCta?: boolean;
}

export interface BreedPageProps extends BreedPageData {}
